import React from "react";
import "./nudgeDetailsContainer.css";
import ThemedCardComponent from "../../../genericComponents/themedCardCompoennt";

function NudgeDetailsContainer({ nudgeData, isExpanded, toggleExpand }) {
  return (
    <ThemedCardComponent
      title={
        <>
          <span
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
            }}
          >
            Summary:
          </span>
        </>
      }
      description={
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
          >
            <p
       
            >
              {nudgeData.event_summary}{" "}
            </p>
           
          </div>
          <div className={`expandable-content ${isExpanded ? "expanded" : ""}`}>
            {nudgeData.cxo_name && nudgeData.cxo_name !== "N/A" && (
              <div style={{display:"flex",flexDirection:"row", justifyContent:"flex-start"}}>
                <div style={{color:"black"}}>CXO Mentions:</div>
                <p style={{marginLeft:"1.2vh  "}}>
                  {nudgeData.cxo_name || "No CXO mentions available."}
                </p>
              </div>
            )}

            {nudgeData.cxo_statement && nudgeData.cxo_statement !== "N/A" && (
              <div style={{display:"flex",flexDirection:"row", justifyContent:"flex-start"}}>
                <div style={{color:"black"}}>CXO Statement:</div>
                <p style={{marginLeft:"0.7vh  "}}>
                  {nudgeData.cxo_statement || "No CXO statement available."}
                </p>
              </div>
            )}

            <div style={{display:"flex",flexDirection:"row", justifyContent:"flex-start"}}>
            <div style={{color:"black"}}>Reference Link:</div>
                {" "}
                <a
                  href={nudgeData.event_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{marginLeft:"1.2vh", textDecoration: "underline"}}
                >
                  Event Link
                </a>
              </div>
            </div>
         

          <div className="mb-3" style={{display:"flex",justifyContent:"flex-end",alignItems:"center"}}>
            <button onClick={toggleExpand} className="nudgeViewMoreBtn">
              {isExpanded ? "View Less" : "View More"}
            </button>
          </div>
        </>
      }
    />
  );
}

export default NudgeDetailsContainer;
